import { Collapse, Typography } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled, { keyframes } from 'styled-components';
import { FontFamily, Truncate } from '../../shared-styles';

const rotate = keyframes`
  from {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(0deg);
  }
`;

export const StyledCollapse = styled(Collapse)`
  width: 100%;
  background-color: ${COLOR_OPTIONS.WHITE};
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 0px;
  overflow: hidden;

  && .ant-collapse-header {
    align-items: center;
    width: 100%;

    padding: 16px;
    ${FontFamily}
    background-color: ${COLOR_OPTIONS.WHITE};
  }

  &&&& .ant-collapse-expand-icon {
    .ant-collapse-arrow {
      font-size: 24px;
      animation: ${rotate} 0.3s ease-in-out forwards;
    }
  }

  && .ant-collapse-title {
    min-width: 0;
    flex: 1;
  }

  &&& .ant-collapse-panel {
    border-top: none;
    background-color: ${COLOR_OPTIONS.NEUTRAL_10};
    border-radius: 0px;
  }

  && .ant-collapse-body {
    padding: 0;
    display: flex;
    flex-direction: column;
  }
`;

export const CollapseHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const HeaderTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const HeaderTitle = styled(Typography.Title)`
  ${FontFamily}
  margin: 0;
  color: ${COLOR_OPTIONS.NEUTRAL_100};
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.105px;

  .title {
    ${Truncate}
    display: inline-block;
  }
`;

export const HeaderDescription = styled(Typography.Text)`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.09px;

  ${FontFamily}
  color: ${COLOR_OPTIONS.NEUTRAL_60};
  margin-top: 4px;
`;

export const DescriptionGroup = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  max-width: 50%;

  &.pest-label {
    max-width: 60%;
  }

  &.crop {
    margin-left: 16px;

    &:before {
      content: '·';
      margin-right: 8px;
      color: ${COLOR_OPTIONS.NEUTRAL_60};
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -0.12px;
    }
  }
`;

export const DescriptionIcon = styled.div`
  margin-right: 4px;
  font-size: 16px;
  flex-shrink: 0;
`;

export const DescriptionText = styled.span`
  ${Truncate}
  flex: 1;
`;

export const LastUpdateText = styled(Typography.Text)`
  ${FontFamily}
  font-size: 12px;
  color: ${COLOR_OPTIONS.NEUTRAL_80};
  background-color: ${COLOR_OPTIONS.NEUTRAL_20};
  padding: 4px 12px;
`;

export const TrapListContainer = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
